export interface RouteConfig {
  path: string;
  label: string;
  accent: string;
  transitionFrom: "left" | "right" | "bottom";
}

export const ROUTES: RouteConfig[] = [
  { path: "/about", label: "about", accent: "#A24BF8", transitionFrom: "left" },
  { path: "/work", label: "work", accent: "#A24BF8", transitionFrom: "left" },
  { path: "/apps", label: "apps", accent: "#A24BF8", transitionFrom: "left" },
  { path: "/crm", label: "crm", accent: "#A24BF8", transitionFrom: "left" },
  { path: "/shop", label: "shop", accent: "#D8602F", transitionFrom: "right" },
  { path: "/contact", label: "contact", accent: "#A24BF8", transitionFrom: "right" },
];

export function getRouteConfig(pathname: string): RouteConfig | undefined {
  return ROUTES.find((r) => pathname.startsWith(r.path));
}
